import { Routes } from '@angular/router';

export const CommonLayout_ROUTES: Routes = [

  {
    path: 'home',
    loadChildren: () => import('../../modules/edit-profile/edit-profile.module').then(m => m.EditProfileModule),
  },

  {
    path: 'manageOrders',
    loadChildren: () => import('../../modules/manage-orders/manage-orders.module').then(m => m.ManageOrdersModule),
  },
  {
    path: 'manageTeams',
    loadChildren: () => import('../../modules/manage-teams/manage-teams.module').then(m => m.ManageTeamsModule),
  },
  {
    path: 'manageItems',
    loadChildren: () => import('../../modules/manageitems/manageitems.module').then(m => m.ManageitemsModule),
  },
  {
    path: 'favouriteOrders',
    loadChildren: () => import('../../modules/favourite-orders/favourite-orders.module').then(m => m.FavouriteOrdersModule),
  },

  {
    path: 'favouriteOrders_players',
    loadChildren: () => import('../../modules/favourite-orders-players/favourite-orders-players.module').then(m => m.FavouriteOrdersPlayersModule),
  },

  {
    path: 'cardDetails',
    loadChildren: () => import('../../modules/card-details/card-details.module').then(m => m.CardDetailsModule),
  },
  {
    path: 'bankingDetails',
    loadChildren: () => import('../../modules/banking-details/banking-details.module').then(m => m.BankingDetailsModule),
  },

  {
    path: 'paymentReq',
    loadChildren: () => import('../../modules/payment-req/payment-req.module').then(m => m.PaymentReqModule),
  },
  {
    path: 'paymentDetails',
    loadChildren: () => import('../../modules/payment-details/payment-details.module').then(m => m.PaymentDetailsModule),
  },

  {
    path: 'contactus',
    loadChildren: () => import('../../modules/contactus/contactus.module').then(m => m.ContactusModule),
  },
  {
    path: 'changesPassword',
    loadChildren: () => import('../../modules/change-password/change-password.module').then(m => m.ChangePasswordModule),
  },

  {
    path: 'playersHomePage',
    loadChildren: () => import('../../modules/players-homepage/players-homepage.module').then(m => m.PlayersHomepageModule),
  },


  {
    path: 'restaurant_edit_profile',
    loadChildren: () => import('../../modules/dashboard/restaurant-edit-profile/restaurant-edit-profile.module').then(m => m.RestaurantEditProfileModule),
  },

  {
    path: 'organization_edit_profile',
    loadChildren: () => import('../../modules/dashboard/organization-edit-profile/organization-edit-profile.module').then(m => m.OrganizationEditProfileModule),
  },

  {
    path: 'team_edit_profile',
    loadChildren: () => import('../../modules/dashboard/team-edit-profile/team-edit-profile.module').then(m => m.TeamEditProfileModule),
  },

  {
    path: 'manageEvents',
    loadChildren: () => import('../../modules/manage-events/manage-events.module').then(m => m.ManageEventsModule),
  },

  {
    path: 'playPromoCodes',
    loadChildren: () => import('../../modules/play-promo-codes/play-promo-codes.module').then(m => m.PlayPromoCodesModule),
  },


];
